import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { InsideSection } from '../components/sales/InsideSection';
import { PainSection } from '../components/sales/PainSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { VisualSection } from '../components/sales/VisualSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { BeforeAfterSection } from '../components/sales/BeforeAfterSection';
import { BenefitsSection } from '../components/sales/BenefitsSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { OfferSection } from '../components/sales/OfferSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalSection } from '../components/sales/FinalSection';
import { SiteFooter } from '../components/sales/SiteFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-221" data-mp="3vp4jg2wbk1fm">
      <header className="border-b border-brand-charcoal/10 bg-brand-paper" data-id="element-222" data-mp="35t059hwhk8dp">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-223" data-mp="35qx2rye5cms3">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-224" data-mp="30ru91a3ma2zf">
            Lash & Brow Instructor Ready™
          </p>
        </div>
      </header>

      <main data-id="element-225" data-mp="3tht1zgkxmk9d">
        <HeroSection data-id="element-226" data-mp="3tg887t6fz5ck" />
        <InsideSection data-id="element-227" data-mp="3ojr9y65j3alr" />
        <PainSection data-id="element-228" data-mp="3okj55fv7r6bi" />
        <SolutionSection data-id="element-229" data-mp="3ok0ydpaxd9pc" />
        <VolumesSection data-id="element-230" data-mp="3oholhqk0xpj5" />
        <VisualSection data-id="element-231" data-mp="3jk4yo299g4fl" />
        <BonusesSection data-id="element-232" data-mp="3jjdc1gxn5h1g" />
        <BeforeAfterSection data-id="element-233" data-mp="3jilew1oebb92" />
        <BenefitsSection data-id="element-234" data-mp="3fitfofkw6hgd" />
        <AudienceSection data-id="element-235" data-mp="3fjkyepte4kp8" />
        <OfferSection data-id="element-236" data-mp="3fi1kh5v7ilqm" />
        <FaqSection data-id="element-237" data-mp="3fkw0ml76tke8" />
        <FinalSection data-id="element-238" data-mp="2859iucyvnwxg" />
      </main>

      <SiteFooter data-id="element-239" data-mp="286ascd08wbd2" />
    </div>;
}